document.addEventListener("DOMContentLoaded", () => {
    let input = document.querySelector('.customizible-checkbox');
    let message = document.querySelector('.product-info__property.file-uploader');
    let form = document.querySelector('.product-info__buy-buttons form[action="/cart/add"]');
    let ATC = document.querySelector('.customizable-leather .add-to-cart-btn');
    let quichCheckout = document.querySelector('.customizable-leather .buy-buttons .shopify-payment-button');
    let productId = document.querySelector('.product-info__buy-buttons form[action="/cart/add"] input[name="id"]');
    let buyButtons = document.querySelector('buy-buttons.buy-buttons');
    let removeDebossing = document.querySelectorAll('.debossing-remove');
    let removeWithDebossing = document.querySelectorAll('.remove-product-with-additional');
    let mainProductId = document.querySelector('input[data-mainProductId]');
    let addedMessage = document.querySelector('.added-product-message');
    let info = document.querySelector("input[data-mainproductid]");
    let infoProductTitle = document.querySelector(".product-info__title");
    let productTitle;
    let checked;
    let variantId;
    let added = false;
    let customizableReader;
    let qty;

    if(mainProductId) {
        mainProductId = mainProductId.getAttribute("data-mainProductId");
    }

    if(infoProductTitle){
        productTitle = infoProductTitle.innerHTML;
    }

    if(message){
        customizableReader = message.getAttribute('data-customizible-leather');
    }

    fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
            for(let i = 0; i < data.items.length; i++){
                if(mainProductId == data.items[i].properties.ProductId) {
                    added = true;
                    qty = data.items[i].quantity;
                }
            }
                removeDebossing.forEach(function (item){
                    item.addEventListener('click', (e)=>{
                        let id = item.getAttribute('data-productid');
                        let removeUrl = item.getAttribute("data-removeUrl");
                        let product_id;
                        let variant_id_related;
                        for(let i = 0; i < data.items.length; i++){
                            if(data.items[i].product_id == id) {
                                if(data.items[i].properties.ProductId) {
                                    product_id = data.items[i].properties.ProductId;
                                }
                            }
                        }

                        for(let i = 0; i < data.items.length; i++){

                            if(product_id == data.items[i].product_id) {
                                variant_id_related = data.items[i].id.toString();
                            }
                        }
                        
                        let ChangeData = {
                            id : variant_id_related,
                            quantity: qty,
                            properties: { 'Image Upload': '' }
                        }

                        fetch('/cart/change.js', {
                            method: 'POST',
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(ChangeData)
                        })
                            .then(response => {
                                window.location.replace(removeUrl);
                                return response.json();
                            })
                            .catch((error) => {
                                console.error('Error:', error);
                            })

                    })
                })
            removeWithDebossing.forEach(function (item){
                item.addEventListener('click', (e)=>{
                    let id = item.getAttribute('data-productid');
                    let removeUrl = item.getAttribute("data-removeUrl");
                    let product_id;
                    for(let i = 0; i < data.items.length; i++){
                        if(data.items[i].properties.ProductId == id) {
                            if(data.items[i].properties.ProductId) {
                                product_id = data.items[i].id.toString();
                            }
                        }
                    }

                    let ChangeData = {
                        id : product_id,
                        quantity: 0,
                    }

                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(ChangeData)
                    })
                        .then(response => {
                            window.location.replace(removeUrl);
                            return response.json();
                        })
                        .catch((error) => {
                            console.error('Error:', error);
                        })
                })
            })


            if(added) {
                if(message) {
                    message.classList.remove('hidden');
                }
                checked = true;
                if(input) {
                    input.checked = checked;
                }
                if(addedMessage) {
                    addedMessage.classList.remove('hidden')
                }
            }
            if(customizableReader){
                document.addEventListener('variant:change', function(event) {
                    let variant = event.detail.variant;
                    variantId = variant.id
                    productTitle = variant.name;
                    productId = event.detail.product.id;
                });

                if(input) {
                    input.addEventListener('change', (event) => {
                        if (event.currentTarget.checked) {
                            message.classList.remove('hidden');
                            checked = true;
                        } else {
                            message.classList.add('hidden');
                            checked = false;
                        }
                    })
                }

                let formData;
                buyButtons.addEventListener('mouseover', ()=> {
                    formData = {
                        'items': [{
                            'id': window.themeVariables.settings.debossing_stamp,
                            'quantity': 1,
                            'properties': {
                                'VariantName': productTitle,
                                'ProductId':  mainProductId
                            }
                        }]
                    };
                })
                if(!added) {
                    ATC?.addEventListener("click", function (event){
                        if(checked) {
                            event.preventDefault();
                        }
                            if(checked) {
                                ATC.setAttribute('aria-busy', "true");
                                fetch(window.Shopify.routes.root + 'cart/add.js', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify(formData)
                                })
                                    .then(response => {
                                        form.submit();
                                        return response.json();
                                    })
                                    .catch((error) => {
                                        console.error('Error:', error);
                                    });
                            }
                    });
                    if(quichCheckout) {
                        quichCheckout.addEventListener("click", function (event){
                            console.log(formData)
                            setTimeout(()=>{
                                if(checked) {
                                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify(formData)
                                    })
                                        .then(response => {
                                            console.log(response.json())
                                            return response.json();
                                        })
                                        .catch((error) => {
                                            console.error('Error:', error);
                                        });
                                }
                            }, 100);
                            // event.returnValue = true;
                        });
                    }


                }
            }
        });

    // document.addEventListener('cart:change', function(event) {
    //     event.preventDefault();
    //     let formData1 = {
    //         'items': [{
    //             'id': window.themeVariables.settings.debossing_stamp,
    //             'quantity': 3
    //         }]
    //     };
    //     fetch(window.Shopify.routes.root + 'cart/add.js', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(formData)
    //     })
    //         .then(response => {
    //             console.log(response.json())
    //             return response.json();
    //         })
    //         .catch((error) => {
    //             console.error('Error:', error);
    //         });
    //     let cart = event.detail.cart; // Get the updated content of the cart
    //     let baseEvent = event.detail.baseEvent; // Get the base event
    //     console.log(11111)
    // });

});
